import { COMPONENT_TYPE } from "@src/tracking/constant";
import { trackByEvent } from "@src/tracking/services";
import { ERROR_SCREEN_TRACKING_EVENTS, TErrorScreen, TErrorScreenCTA } from ".";
interface ITrackingArguments {
    country : string,
    language : string
}
export const trackErrorScreen = ({country, language} : ITrackingArguments) => {
    const { alert_action, alert_type, siteType, component_name, component_type } = ERROR_SCREEN_TRACKING_EVENTS.ERROR_SCREEN_TRACKING
    try {
        const trackData: TErrorScreen = {
            component_name,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language,
            country,
            alert_action,
            alert_type,
            siteType
        }
        trackByEvent<TErrorScreen>(ERROR_SCREEN_TRACKING_EVENTS.ERROR_SCREEN_TRACKING.event, trackData)
    } catch (error) {
        console.log('trackErrorPageInitialized error', error);
    }
}


export const trackErrorScreenCTA = ({country, language} : ITrackingArguments) => {
    const { alert_action, alert_type, siteType, component_name, component_type } = ERROR_SCREEN_TRACKING_EVENTS.ERROR_SCREEN_CTA_TRACKING
    try {
        const trackData: TErrorScreenCTA = {
            component_name,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language,
            country,
            alert_action,
            alert_type,
            siteType
        }
        trackByEvent<TErrorScreenCTA>(ERROR_SCREEN_TRACKING_EVENTS.ERROR_SCREEN_CTA_TRACKING.event, trackData)
    } catch (error) {
        console.log('trackErrorPageInitialized error', error);
    }
}